export interface HttpError {
  message: string;
  error: any;
  status: number;
  type: 'network' | 'server';
  debug?: any;
}

export class HttpTimeoutError implements HttpError {
  message: 'Connection timed out.';
  error: 'Connection timed out.';
  status: 503;
  type: 'server';
}
